import { FormValueScope } from '@epages/react-components'
import Immutable from 'immutable'
import cc from 'classcat'

import { useTranslate, withComponents } from '../../utils/translate'
import FormGroup from '../formComponents/FormGroup'
import FormValue from '../formComponents/FormValue'
import useHelpCenterLink from '../../utils/hooks/useHelpCenterLink'

const options = ['row', 'column']

export default function FooterLayoutSettings() {
  const helpCenterUrl = useHelpCenterLink('FOOTER_LAYOUT')

  const t = useTranslate('interface', 'components.bottomBar.footerSettings.layout')

  return (
    <>
      <div className="dali-settingslayer-element small">
        {withComponents(t)('description', {
          link: (
            <a
              className={cc(['ep-form-row-text-external-link'])}
              href={helpCenterUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('linkText')}
            </a>
          ),
        })}
      </div>
      <div className="dali-settingslayer-element">
        <FormValueScope name="footerLayout">
          <FormValue name="variant">
            {(variant: string, setVariant: (data: string) => void) => {
              return options.map((layoutType) => (
                <div key={layoutType} className="ep-form-row">
                  <FormGroup
                    name="layoutType"
                    className="ep-footer-layout-settings-form"
                    label={t(`layoutTypes.${layoutType}s.label`)}
                    info={t(`layoutTypes.${layoutType}s.tooltip`)}
                    tagName="label"
                    labelAfterComponent
                  >
                    <input
                      type="radio"
                      name="layoutType"
                      value={layoutType}
                      checked={variant === layoutType}
                      onChange={() => {
                        setVariant(layoutType)
                      }}
                    />
                  </FormGroup>
                  <button
                    type="button"
                    className={cc(['ep-footer-layout-scheme', [`ep-footer-layout-scheme-${layoutType}`]])}
                    onClick={() => {
                      setVariant(layoutType)
                    }}
                  >
                    {layoutType === 'row' ? (
                      <div className="flex">
                        <div className="row">
                          <div className="page"></div>
                          <div className="page"></div>
                          <div className="page"></div>
                          <div className="page"></div>
                        </div>
                        <div className="row">
                          <div className="page"></div>
                          <div className="page"></div>
                          <div className="page"></div>
                        </div>
                        <div className="row row-logo">
                          <div className="logo"></div>
                          <div className="logo"></div>
                          <div className="logo"></div>
                          <div className="logo"></div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex">
                        <div className="row">
                          <div className="headline"></div>
                          <div className="page"></div>
                          <div className="page"></div>
                          <div className="page"></div>
                          <div className="page"></div>
                        </div>
                        <div className="row">
                          <div className="headline"></div>
                          <div className="page"></div>
                          <div className="page"></div>
                          <div className="page"></div>
                        </div>
                        <div className="row row-logo">
                          <div className="headline"></div>
                          <div className="logo"></div>
                          <div className="logo"></div>
                          <div className="logo"></div>
                          <div className="logo"></div>
                        </div>
                      </div>
                    )}
                  </button>
                </div>
              ))
            }}
          </FormValue>
        </FormValueScope>
      </div>
    </>
  )
}

FooterLayoutSettings.defaultValue = {
  footerLayout: Immutable.fromJS({ variant: 'row' }),
}
